import { Component, ElementRef, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { TransactionsWithDirectorsService } from './service/transactions-with-directors.service';
import * as CryptoJS from 'crypto-js';
import { Router } from '@angular/router';
import { CommonService } from '../../../../shared/common.service';
import { OfficerscompanyService } from '../../officerscompany/Service/officerscompany.service';
import { Observable } from 'rxjs';
import { SideNavService } from '../../../../theme/layout/admin/navigation/service/side-nav.service';

@Component({
  selector: 'app-transactions-with-directors',
  templateUrl: './transactions-with-directors.component.html',
  styleUrls: ['./transactions-with-directors.component.scss']
})
export class TransactionsWithDirectorsComponent implements OnInit {
  Transactionswithdirectors: FormGroup;
  TransactionswithdirectorsGrid: FormGroup;
  Gridata = [];
  index: any;
  officerdata: any
  isJump: any;
  NormalRoutng: boolean;
  showBubbledata: any;
  disabledirectorgrid: boolean;
  valid: boolean = true;
  constructor(private Formbuilder: FormBuilder, private modalService: NgbModal, public TransactionsWithDirectorsService: TransactionsWithDirectorsService, public commonService: CommonService, private router: Router, public officer: OfficerscompanyService, private sidenav: SideNavService) {
  }

  ngOnInit() {
    debugger;
    this.GetOfficerscompany();
    this.commonService.getIncomeStatementsHeaders();
    this.createformgroup();
    this.createformgroupGrid();
    this.getTransactionsWithDirectors();
    this.isJump = localStorage.getItem('isJump');
  this.clearfield();
    this.commonService.getNotesData();

    //this.commonService.Showbubble.subscribe((data) => {
    //  if (data) {
        this.commonService.getImportPageSelectionData(this.commonService.AccountTemplateId, CryptoJS.AES.decrypt(localStorage.getItem("companyId"), "APS").toString(CryptoJS.enc.Utf8), this.Transactionswithdirectors.controls['APPeriodId'].value).subscribe((data) => {
          this.commonService.showBubble = data[0].ImportStatus
          if (this.commonService.showBubble) {
            this.sidenav.setShowBubble(true)
            this.getTransactionsWithDirectors_LY()
          }
        })
    //  }
    //  else {
    //    this.showBubbledata = null
    //  }
    //})

   
  }

  openVerticallyCentered(content2: ElementRef) {
    debugger;
    this.valid = true;
    this.TransactionswithdirectorsGrid.reset();
    //this.TransactionswithdirectorsGrid.controls['NameEntityOfficer'].setValue("Accountant")
    this.modalService.open(content2, { size: 'lg', centered: true, backdrop: 'static', keyboard: false });
  }

  createformgroup() {
    this.Transactionswithdirectors = this.Formbuilder.group({
      TransactionsWithDirectorsId: new FormControl(),
      MasterId: new FormControl(),
      DirectorsAdvancesCreditGuaranteesFreeøtextComment: new FormControl(),
      IsDelete: new FormControl(),
      APPeriodId: new FormControl(CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)),
      CreatedBy: new FormControl(localStorage.getItem('LoginuserId')),
      CreatedDate: new FormControl(),
      ModifiedBy: new FormControl(),
      ModifiedDate: new FormControl(),
    });
  }


  createformgroupGrid() {
    this.TransactionswithdirectorsGrid = this.Formbuilder.group({
      DetailsId: new FormControl(),
      TransactionsWithDirectorsId: new FormControl(),
      OfficersoftheCompanyId: new FormControl(),
      DescriptionSpecificAdvanceOrCreditItsConditionsDirectors: new FormControl(),
      AdvancesCreditsDirectors_1: new FormControl(),
      AdvancesCreditsMadeInPeriodDirectors: new FormControl(),
      AdvancesCreditsRepaidInPeriodDirectors: new FormControl(),
      AdvancesCreditsDirectors_2: new FormControl({value:'',disabled:true}),
      NameEntityOfficer: new FormControl(null),
      APPeriodId: new FormControl(CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)),
      CreatedBy: new FormControl(),
      CreatedDate: new FormControl(),
      ModifiedBy: new FormControl(),
      ModifiedDate: new FormControl(),
    });
  }

  clear: any
  clearfield() {
    debugger
    this.clear = this.commonService.clearAllFields.subscribe((data: boolean) => {
      if (data) {
        debugger;
        this.Transactionswithdirectors.reset();
        this.Transactionswithdirectors.controls['APPeriodId'].setValue(CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8));
        this.Gridata = [];
      }
    })
  }


  Submit() {
    debugger;
    if (this.SaveDirector()) {
      if (this.index != null) {
        this.Gridata[this.index].NameEntityOfficer = this.TransactionswithdirectorsGrid.controls['NameEntityOfficer'].value,
          this.Gridata[this.index].AdvancesCreditsDirectors_1 = this.TransactionswithdirectorsGrid.controls['AdvancesCreditsDirectors_1'].value,
          this.Gridata[this.index].AdvancesCreditsMadeInPeriodDirectors = this.TransactionswithdirectorsGrid.controls['AdvancesCreditsMadeInPeriodDirectors'].value,
          this.Gridata[this.index].AdvancesCreditsRepaidInPeriodDirectors = this.TransactionswithdirectorsGrid.controls['AdvancesCreditsRepaidInPeriodDirectors'].value,
          this.Gridata[this.index].AdvancesCreditsDirectors_2 = this.TransactionswithdirectorsGrid.controls['AdvancesCreditsDirectors_2'].value,
          this.Gridata[this.index].AdvancesCreditsDirectors_1 = this.TransactionswithdirectorsGrid.controls['AdvancesCreditsDirectors_1'].value,
          this.Gridata[this.index].DescriptionSpecificAdvanceOrCreditItsConditionsDirectors = this.TransactionswithdirectorsGrid.controls['DescriptionSpecificAdvanceOrCreditItsConditionsDirectors'].value
      }
      else {
        this.Gridata.push({
          NameEntityOfficer: this.TransactionswithdirectorsGrid.controls['NameEntityOfficer'].value,
          AdvancesCreditsDirectors_1: this.TransactionswithdirectorsGrid.controls['AdvancesCreditsDirectors_1'].value,
          AdvancesCreditsMadeInPeriodDirectors: this.TransactionswithdirectorsGrid.controls['AdvancesCreditsMadeInPeriodDirectors'].value,
          AdvancesCreditsRepaidInPeriodDirectors: this.TransactionswithdirectorsGrid.controls['AdvancesCreditsRepaidInPeriodDirectors'].value,
          AdvancesCreditsDirectors_2: this.TransactionswithdirectorsGrid.controls['AdvancesCreditsDirectors_2'].value,
          DescriptionSpecificAdvanceOrCreditItsConditionsDirectors: this.TransactionswithdirectorsGrid.controls['DescriptionSpecificAdvanceOrCreditItsConditionsDirectors'].value,
        })
  
      }
      this.index = null;
      this.modalService.dismissAll();
      return true;
    }
    else {
      return false;
    }

  }

  Close() {
    debugger;
    if (this.TransactionswithdirectorsGrid.dirty) {
      Swal.fire({
        title: "Andica Accounts Production",
        html: "<span style='font-weight: 900'>You have unsaved data.</span> <br><span>Do you want to save your changes before leaving?</span>",
        icon: "warning",
        confirmButtonText: "Save Changes",
        showCancelButton: true,
        cancelButtonText: "Discard Changes",
        allowOutsideClick: false
      }).then((data) => {
        if (data.value)
          if (this.Submit()) {
            this.modalService.dismissAll();
          }
      })
    }
    else {
      this.modalService.dismissAll();
    }
  }

  deletegridDetails(index) {
    Swal.fire({
      titleText: "Andica Accounts Production",
      text: 'Are you sure you want to delete?',
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      allowOutsideClick: false
    }).then((result) => {
      if (result.value) {
        this.Gridata.splice(index, 1);
      } else if (result.dismiss === Swal.DismissReason.cancel) {

      }
    })
  }

  EditgridDetails(content2, index) {
    debugger;
    this.index = index;
    this.TransactionswithdirectorsGrid.reset();
    this.modalService.open(content2, { size: 'lg', centered: true, backdrop: 'static', keyboard: false });
    var data = this.Gridata[index];
    this.TransactionswithdirectorsGrid.patchValue(data);

  }
  MainData:any=[]
  SaveData() {
    debugger;
    this.MainData = []
    if (this.NextDirector()) {
      var data = this.Transactionswithdirectors.value;
      this.MainData.push(data);
      this.Gridata = this.Gridata.filter(x => x.NameEntityOfficer != null)
      if (this.Gridata.length > 0) {
        this.MainData.push(...this.Gridata);
      }
      this.TransactionsWithDirectorsService.insertdetails(this.MainData).subscribe(data => {
        this.Transactionswithdirectors.markAsPristine();
        this.TransactionswithdirectorsGrid.markAsPristine();
        if (this.NormalRoutng)
          return true;
        var nextPage;
        nextPage = this.commonService.getNextNoteSelection("Transactions with directors", this.commonService.NotesList)
        if (this.isJump == 'true')
          this.router.navigate(['/notes'])
        else if (nextPage == 'transactionswithdirectors') {
          nextPage = this.commonService.getNextPageSelection("Notes", this.commonService.allPagesdata)
          this.router.navigate([nextPage]);
        }
        else {
          this.router.navigate([nextPage]);
        }
      })
    }
    else {
      this.NormalRoutng = false;
      return false;
    }
  }

  Back() {
    this.Transactionswithdirectors.markAsPristine();
    var backpage;
    if (this.isJump == 'true')
      this.router.navigate(['/notes'])
    else {
      backpage = this.commonService.getBackSelection("Transactions with directors", this.commonService.NotesList)
      this.router.navigate([backpage]);
    }
  }

  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    debugger;
    if (this.Transactionswithdirectors.dirty || this.TransactionswithdirectorsGrid.dirty) {
      return Swal.fire({
        title: "Andica Accounts Production",
        html: "<span style='font-weight: 900'>You have unsaved data.</span> <br>Do you want to save your changes before leaving?",
        icon: "warning",
        confirmButtonText: "Save Changes",
        showCancelButton: true,
        cancelButtonText: "Discard Changes",
        allowOutsideClick: false
      }).then((result) => {
        if (result.value) {
          this.NormalRoutng = true;
          if (this.SaveData())
            return true;
          else if (!this.NormalRoutng)
            return false;
        }
        else {
          return true;
        }
      })
    }
    else if (this.commonService.routeToCompanyList) {
      return true
    }
  }

  TotalBack() {
    debugger;
    //if (this.TransactionswithdirectorsGrid.dirty) {
    //  Swal.fire({
    //    title: "Andica Accounts Production",
    //    html: "You have unsaved data. <br>Do you want to save your changes before leaving?",
    //    icon: "question",
    //    confirmButtonText: "Save Changes",
    //    showCancelButton: true,
    //    cancelButtonText: "Discard Changes",
    //    allowOutsideClick: false
    //  }).then((data) => {
    //    if (data.value) {
    //      this.commonService.DisplayAccountingPeriodlist = true;
    //      this.router.navigate(['/businesslist']);
    //    }
    //  })
    //}
    //else {
      this.commonService.DisplayAccountingPeriodlist = true;
      this.router.navigate(['/business']);
    //}
  }

  getTransactionsWithDirectors() {
    debugger;
    this.TransactionsWithDirectorsService.getdata(this.TransactionswithdirectorsGrid.controls['APPeriodId'].value).subscribe((data: any) => {
      this.Transactionswithdirectors.patchValue(data[0])
      for (var i = 1; i < data.length; i++) {
        this.Gridata.push({
          NameEntityOfficer: data[i].NameEntityOfficer,
          AdvancesCreditsDirectors_1: data[i].AdvancesCreditsDirectors_1,
          AdvancesCreditsMadeInPeriodDirectors: data[i].AdvancesCreditsMadeInPeriodDirectors,
          AdvancesCreditsRepaidInPeriodDirectors: data[i].AdvancesCreditsRepaidInPeriodDirectors,
          AdvancesCreditsDirectors_2: data[i].AdvancesCreditsDirectors_2,
          DescriptionSpecificAdvanceOrCreditItsConditionsDirectors: data[i].DescriptionSpecificAdvanceOrCreditItsConditionsDirectors,
        })
        if (localStorage.getItem("SubmitStatus") == "true") {
          this.Transactionswithdirectors.disable()
          this.TransactionswithdirectorsGrid.disable()
          this.disabledirectorgrid = true;
        }
      }
     
    })
  }
  getTransactionsWithDirectors_LY() {
    debugger;
    this.TransactionsWithDirectorsService.getdata_LY(this.TransactionswithdirectorsGrid.controls['APPeriodId'].value).subscribe((data: any) => {
      this.showBubbledata = data;
    })
  }

  calculations() {
    var total = +this.TransactionswithdirectorsGrid.controls["AdvancesCreditsDirectors_1"].value + (+this.TransactionswithdirectorsGrid.controls["AdvancesCreditsMadeInPeriodDirectors"].value) - (+this.TransactionswithdirectorsGrid.controls["AdvancesCreditsRepaidInPeriodDirectors"].value);
    this.TransactionswithdirectorsGrid.controls["AdvancesCreditsDirectors_2"].setValue(total)
  }

  GetOfficerscompany() {
    debugger;
    let id = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)
    this.officer.GetOneOfficerscompany(id).subscribe((data: any) => {
      this.officerdata = data.filter(x => x.NameOfDirector != null);
    });
  }

  SaveDirector() {
    debugger
    if (this.TransactionswithdirectorsGrid.controls['NameEntityOfficer'].value == "" || this.TransactionswithdirectorsGrid.controls['NameEntityOfficer'].value == null) {
      //Swal.fire("Andica Accounts Production", "Name of director must be completed.", "warning");
      this.valid = false;
      return false
    }
    else {
      this.valid = true;
    }
    return true;
  }

  NextDirector() {
    debugger
    if (this.Gridata.length > 0) {
      for (var i = 0; i < this.Gridata.length; i++) {
        var data = this.Gridata.filter(x => x.NameEntityOfficer == this.Gridata[i].NameEntityOfficer)

        if (data.length > 1) {
            Swal.fire("Andica Accounts Production", "Name of director is already present.", "warning");
          return false
        }
      }
      return true;
    }
    else {
      return true;
    }

  }

}
